export enum RemarkInputType {
  /** 0: text */
  Text,
  /** 1: date selector */
  DateSelector,
  /** 2: date time selector */
  DateTimeSelector,
  /** 3: radio */
  Radio,
  /** 4: quantity */
  Quantity,
  /** 5: 國碼手機號碼 */
  NationalPhoneNumber,
  /** 6:複選選項 */
  Checkbox,
  /** 7:純文字敘述 */
  Description,
  /** 8:圖片 */
  Image,
  /** 9:tags */
  Tags,
}

export enum RemarkRegexType {
  /** 0: no regex */
  None,
  /** 1: TW mobile */
  TWMobile,
}

export enum RemarkIdEnum {
  /** 2: 手機電話 (國碼) */
  PHONE_NUMBER = 2,
  /** 5: Email */
  EMAIL = 5,
  /** FunNow 純預訂退改 checkbox rule remark */
  PURE_BOOKING_RULE_ID_1 = 7245,
  /** FunNow 純預訂退改 checkbox rule remark */
  PURE_BOOKING_RULE_ID_2 = 7246,
}

export const RemarkPureBookingRuleIds = [RemarkIdEnum.PURE_BOOKING_RULE_ID_1, RemarkIdEnum.PURE_BOOKING_RULE_ID_2]

export interface FormFieldOptionCreationData {
  sub_id: number
  content: string
}

export interface ProductSeatsResponse {
  seat_id: number
  seat_name: string
  lang_for_usen: string
}

export interface OrderSeatsParams {
  id: number
  name: string
  lang_for_usen?: string
}
